var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('button',{class:'btn btn-'+_vm.color},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")]):_c('button',{class:'btn btn-'+_vm.color},[_c('loading-spinner',{attrs:{"color":"white"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }